import { Component, OnInit } from '@angular/core';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { ConfirmationService, } from 'primeng/api';
import { ActivatedRoute } from '@angular/router'
import { CoreService } from '../core/_services/core.services';
import { AlertasService } from '../core/_services/alerta.service';
import { NgxSpinnerService } from 'ngx-spinner';
import { AppBreadcrumbService } from '../consola/app.breadcrumb.service';
import { ValidatorUtils } from '../core/_util/validator-util';
import { distinctUntilChanged } from 'rxjs/operators';
import { forkJoin } from 'rxjs';

interface experiencia {
  name: string,
  code: string
}

@Component({
  selector: 'app-ficha',
  templateUrl: './ficha.component.html',
  styleUrls: ['./ficha.component.scss']
})
export class FichaComponent extends ValidatorUtils implements OnInit {
  [x: string]: any;

  //formulario
  formBuilder: FormBuilder;
  formularioFicha: FormGroup;
  formularioActividades: FormGroup;
  fomulario1: FormGroup;
  mostrarFormulario: Boolean = false;
  registroNuevo: Boolean = false;
  submitted: Boolean = false;

  registrosListaConocimientos: any;
  listaClientes: any[] = [];
  registrosConocimientos: any = [];
  listaDisponiblesConocimientos: any[] = [];
  listaAsignadosOrigConocimientos: any[] = [];
  listaCategoriasConocimientos: any[] = [];
  listaAsignadosConocimientos: any[] = [];
  escolaridades: any;
  genero: any;
  pruebas: any;
  referenciaciones: any;
  documentos: any[];
  descripcion: any[];
  informe: any;

  listaAsignadosCompetencias: any[] = [];
  listaDisponiblesCompetencias: any[] = [];

  listaAsignadosHabilidades: any[] = [];
  listaDisponiblesHabilidades: any[] = [];
  fichaActual: any = '';
  clienteSeleccionado: any;
  cargoSeleccionado: any;
  clienteCargado: any;
  cargoCargado: any;
  cargoGenerico: any;
  perfilSeleccionado: any;
  estadoSeleccionado: any;
  rangoSeleccionado: any;
  documentosSeleccionados: any[];
  listaCargos: any = [];
  listaPerfil: any = [];
  listaCiudad: any = [];
  listaCaracteristica: any = [];
  listaDocumentos: any[];
  listaReferenciacion: any;
  listaPruebas: any;
  listaGeneros: any;
  listaExperiencias: any[];
  listaEscolaridad: any;
  listaJornadas: any[];
  listaAspiracion: any[];
  listaNegocios: any[];
  estadoFicha: any;
  semestre: any[];
  procesos: any;
  ciudad: any;
  departamento: any;
  pais: any;

  negocio: any;

  listaActividades: any[];
  listaActividadesFiltradas: any[];
  varObser: boolean = false;
  varDes: boolean = false;
  registrosListaActividades: any;
  totalRecordsActividades: any;
  actividadActualSelec: any;
  columnasActividades: any[];

  listaAsignadosFormacionReq: any[] = [];
  listaDisponiblesFormacionReq: any[] = [];

  listaAsignadosProfesiones: any[] = [];
  listaDisponiblesProfesiones: any[] = [];

  fichaGeneral: any;
  fichaAuciliar: any;

  constructor(
    public coreService: CoreService,
    public spinner: NgxSpinnerService,
    public msj: AlertasService,
    private route: ActivatedRoute,
    public confirmationService: ConfirmationService,
    private breadCrumbService: AppBreadcrumbService

  ) {
    super();
    this.breadCrumbService.setItems([
      { label: 'Ficha' }
    ]);

    this.formBuilder = new FormBuilder();
    // this.listaExperiencias = [
    //   { name: 'NO REQUIERE', code: 'no' },
    //   { name: '1 - 6 MESES', code: 1 },
    //   { name: '6 - 12 MESES', code: 2 },
    //   { name: '1 - 2 AÑOS', code: 3 },
    //   { name: 'MAS DE 2 AÑOS', code: 4 }
    // ];

    this.estadoFicha = [
      { name: 'ACTIVA', code: 1 },
      { name: 'INACTIVA', code: 0 }
    ];

    this.formulario = this.formBuilder.group({

      experiencia: ['', Validators.required],
      escolaridad: ['', Validators.required],
      genero: ['', Validators.required],
      semestre: [''],
      rangoinicial: [],
      rangofinal: [],
      valor: [],
      observacion: [],
      text_publicacion: ['', [ Validators.required, Validators.maxLength(4000)]],
    });
    this.formulario1 = this.formBuilder.group({
      clienteCargado: [''],
      cargoCargado: [''],
      clienteSeleccionado: ['', Validators.required],
      cargoSeleccionado: ['', Validators.required],
      perfilSeleccionado: ['', Validators.required],
      estadoSeleccionado: ['', Validators.required],
      ciudad: ['', Validators.required],
      departamento: [''],
      pais: [''],
      negocio: ['', Validators.required],
    });

    this.formularioActividades = this.formBuilder.group({
      actividadSelec: [],
      descripcionActividades: [''],
      observacionActividades: ['']
    });

    this.formulario2 = this.formBuilder.group({
      entrevista: [],
      entrevista_cliente: [],
      seguridad: [],
      informe: [],
      domiciliaria: [],
      listaJornadas: [],
      listaJornadas2: [],
      rangoSeleccionado: [],
      horario: [],
      documentos_nuevos: [],
      referenciacion_nuevo: [],
      pruebas_psico: [],
      variable: [],
      v_variable: [],
      comision: [],
      v_comision: [],
      rodamiento: [],
      v_rodamiento: [],
      movilizacion: [],
      v_movilizacion: [],
      f_basicas: [],
      estaturamin: ['', Validators.required],
      estaturamax: ['', Validators.required],
      edadmin: ['', Validators.required],
      edadmax: ['', Validators.required],
      otros: [],
      restriciones: [],
      fobservaciones: []
    });
  }

  ngOnInit(): void {
    this.spinner.show();
    this.registroNuevo = true;
    setTimeout(() => {
      this.formulario2.get('seguridad').valueChanges.pipe(distinctUntilChanged())
        .subscribe(
          cambio => {
            if (cambio != null && cambio != undefined) {
              this.cambioDomiciliario(cambio);
            }
          }
        )
    })
    this.informe = 'no';
    this.domiciliaria = 'no';
    this.seguridad = 'no';
    this.variable = 'no';
    this.comision = 'no';
    this.rodamiento = 'no';
    this.movilizacion = 'no';

    if (this.route.snapshot.queryParams.id) {
      this.fichaActual = this.route.snapshot.queryParams['id'];
    }

    this.consultaMultipleListas();

  }

  consultaMultipleListas() {
    const clientesLista = this.coreService.get('/obtenerClientes');
    const cargosLista = this.coreService.get('/listas/cargosConocimientosEspecificos');
    const caracteristicasLista = this.coreService.get('/obtenerCaracteristica');
    const validacionesLista = this.coreService.get('/obtenerValidaciones');
    const condicionesLista = this.coreService.get('/obtenerCondiciones');
    const actividadesLista = this.coreService.get('/listas/actividadesAdicionales');
    const perfilesLista = this.coreService.get('/obtenerPerfil');
    const experiencia = this.coreService.get("/listas/experiencia");

    this.spinner.show();
    forkJoin([clientesLista, cargosLista, caracteristicasLista, validacionesLista, condicionesLista, actividadesLista, perfilesLista, experiencia])
      .subscribe(
        (res: any) => {
          this.listaClientes = res[0].clientes;

          this.listaNegocios = res[0].unidad;

          this.listaCategoriasConocimientos = res[1];

          this.listaCaracteristica = res[2];

          this.listaDocumentos = res[3].documentos;
          this.listaReferenciacion = res[3].referenciaciones;
          this.listaPruebas = res[3].pruebas;

          this.listaGeneros = res[4].genero;
          this.listaAspiracion = res[4].aspiracion;
          this.listaEscolaridad = res[4].escolaridades;

          this.listaActividades = res[5];
          this.listaActividadesFiltradas = res[5];

          this.listaPerfil = res[6];

          this.listaExperiencias = res[7];

          if (this.fichaActual != '') {
            this.getFicha();
          } else {
            this.spinner.hide();
          }

        },
        err => {
          this.spinner.hide();
          this.addSingleMessage('error', 'Atención', 'Error al conectar el servicio de datos de listas');
        }
      );
  }

  consultaMultipleDatosAsignados() {

    let params = {
      fichaActual: this.fichaActual
    };

    const conocimientosLista = this.coreService.getWithParams('/index-ficha-conocimientos', params);
    const competenciasLista = this.coreService.getWithParams('/index-ficha-competencias', params);
    const habilidadesLista = this.coreService.getWithParams('/index-ficha-habilidades', params);
    const actividadesLista = this.coreService.getWithParams('/actividades-adicionales-ficha', params);
    const cargosLista = this.coreService.getWithParams('/obtenerCargos', { id_cliente: this.fichaGeneral.cliente_id });
    const documentosLista = this.coreService.getWithParams('/listar-documentos', params);
    const procesosLista = this.coreService.getWithParams('/listar-procesos', params);
    const referenciasLista = this.coreService.getWithParams('/listar-referencias', params);

    this.spinner.show();
    forkJoin([conocimientosLista, competenciasLista, habilidadesLista, actividadesLista, cargosLista, documentosLista, procesosLista, referenciasLista])
      .subscribe(
        (res: any) => {

          // conocimientos
          this.listaAsignadosOrigConocimientos = res[0].listaTotal;
          this.listaAsignadosConocimientos = res[0].listaFichaActual;
          let disponiblesConocimientos = res[0].listaTotal;
          this.listaAsignadosConocimientos.forEach((item, index) => {
            disponiblesConocimientos = disponiblesConocimientos.filter(function (dispo) {
              return dispo.id !== item.id;
            });
          });
          this.listaDisponiblesConocimientos = disponiblesConocimientos;

          // competencias
          this.listaAsignadosCompetencias = res[1].listaFichaActual;
          let disponiblesCompetencias = res[1].listaTotal;
          if (disponiblesCompetencias) {
            disponiblesCompetencias.forEach((item, index) => {
              this.listaAsignadosCompetencias.forEach((i) => {
                if (i.des_referencia === item.des_referencia) {
                  disponiblesCompetencias.splice(index, 1);
                }
              })
            });
          }
          this.listaDisponiblesCompetencias = disponiblesCompetencias;

          // habilidades
          this.listaAsignadosHabilidades = res[2].registros_seleccionados;
          let disponiblesHabilidades: any[] = res[2].listaTotal;
          if (this.listaAsignadosHabilidades) {
            disponiblesHabilidades.forEach((item, index) => {
              this.listaAsignadosHabilidades.forEach((i) => {
                if (i.des_referencia === item.des_referencia) {
                  disponiblesHabilidades.splice(index, 1);
                }
              })
            });
          }
          this.listaDisponiblesHabilidades = disponiblesHabilidades;

          // actividades
          this.columnasActividades = [
            { header: 'Actividad', field: 'des_referencia' },
            { header: 'Descripción', field: 'descripcion_otra' },
            { header: 'Observación', field: 'observaciones' }
          ];
          this.registrosListaActividades = res[3].actividades;
          this.totalRecordsActividades = res[3].actividades.length;

          // documentos
          this.formulario2.controls['documentos_nuevos'].setValue(res[5]);

          // referencias
          this.formulario2.controls['referenciacion_nuevo'].setValue(res[6]);

          // pruebas
          this.formulario2.controls['pruebas_psico'].setValue(res[7]);

          this.asignarFichaGeneral();

        },
        err => {
          this.spinner.hide();
          this.addSingleMessage('error', 'Atención', 'Error al conectar el servicio de datos de listas');
        }
      );
  }

  cambioDomiciliario(cambio) {
    if (cambio == 'si') {
      this.formulario2.controls['domiciliaria'].setValue('si');
    }
  }

  volver() {
    this.mostrarFormulario = false;
    this.submitted = false;
  }

  prepararNuevo() {
    this.mostrarFormulario = true;
    this.registroNuevo = true;
  }

  /**
  * listados Conocimientos Especificos
  */
  getListaConocimientos() {
    this.coreService.get('/listas/cargosConocimientosEspecificos').subscribe(
      (res: any) => {
        this.listaCategoriasConocimientos = res;
      },
      (err: any) => {
      }
    )
  }

  getFicha() {
    let params = {
      id: this.fichaActual
    }
    this.coreService.getWithParams('/consulta-ficha', params).subscribe(
      (res: any) => {
        this.fichaGeneral = res.ficha;
        
        this.formulario1.controls['clienteCargado'].setValue(res.ficha.cliente.nombre);
        this.formulario1.controls['cargoCargado'].setValue(res.ficha.cargo.descripcion);
        this.clienteCargado = res.ficha.cliente.cliente_id;
        this.cargoCargado = res.ficha.cargo.id;
        this.formulario1.controls['clienteSeleccionado'].setValue(res.ficha.cliente);
        this.formulario1.controls['cargoSeleccionado'].setValue(res.ficha.cargo);
        this.cargoGenerico = res.ficha.cargo_generico;
        this.fichaAuxiliar = res.auxiliar_ficha;
        this.fichaActividad = res.actividad;
        this.registroNuevo = false;
        console.log(res.ficha.text_publicacion);
        
        this.formulario.controls['text_publicacion'].setValue(res.ficha.text_publicacion);

        this.fichaAuxiliar.forEach(elemento => {
          if (elemento.valor == 'entrevista') {
            this.formulario2.controls['entrevista'].setValue(true);
          }
          if (elemento.valor == 'entrevista_cliente') {
            this.formulario2.controls['entrevista_cliente'].setValue(true);
          }
          this.FichaJornada = res.jornadas_ficha;
        });
        this.consultaMultipleDatosAsignados();
      },
      (err: any) => {
      }
    )
  }

  getListaConocimientosAsignados() {
    let params = {
      fichaActual: this.fichaActual
    };
    this.coreService.getWithParams('/index-ficha-conocimientos', params).subscribe(
      (res: any) => {
        this.listaAsignadosOrigConocimientos = res.listaTotal;
        this.listaAsignadosConocimientos = res.listaFichaActual;

        let disponibles = res.listaTotal;

        this.listaAsignadosConocimientos.forEach((item, index) => {
          disponibles = disponibles.filter(function (dispo) {
            return dispo.id !== item.id;
          });
        });
        this.listaDisponiblesConocimientos = disponibles;
      },
      (err: any) => {
      }
    )
  }

  /**
  * listados Competencias
  */
  getListaCompetenciasDisponibles() {
    let params = {
      fichaActual: this.fichaActual
    };
    this.coreService.getWithParams('/index-ficha-competencias', params).subscribe(
      (res: any) => {
        this.listaAsignadosCompetencias = res.listaFichaActual;
        let disponibles = res.listaTotal;
        if (disponibles) {
          disponibles.forEach((item, index) => {
            this.listaAsignadosCompetencias.forEach((i) => {
              if (i.des_referencia === item.des_referencia) {
                disponibles.splice(index, 1);
              }
            })
          });
        }
        this.listaDisponiblesCompetencias = disponibles;
      },
      (err: any) => {
      }
    )
  }
  /**
  * listados Habilidades
  */
  getListaHabilidadesDisponibles() {
    let params = {
      fichaActual: this.fichaActual
    };
    this.coreService.getWithParams('/index-ficha-habilidades', params).subscribe(
      (res: any) => {
        this.listaAsignadosHabilidades = res.registros_seleccionados;
        let disponibles: any[] = res.listaTotal;
        disponibles.forEach((item, index) => {
          this.listaAsignadosHabilidades.forEach((i) => {
            if (i.des_referencia === item.des_referencia) {
              disponibles.splice(index, 1);
            }
          })
        });
        this.listaDisponiblesHabilidades = disponibles;
      },
      (err: any) => {
      }
    )
  }
  /**
   * filtro
   */
  filtradoConocimientos(evento) {
    this.listaDisponiblesConocimientos = this.listaAsignadosOrigConocimientos.filter(opcion => evento.value.find(seleccionado => seleccionado.cod_tip_referencia == opcion.cod_tip_referencia))
  }

  filtradoActividades(evento) {
    console.log(evento);
    if (evento.value.length == 0) {
      this.getListaActividades();
      this.formularioActividades = this.formBuilder.group({
        actividadSelec: [],
        descripcionActividades: [''],
        observacionActividades: ['']
      })
      this.actividadActualSelec = evento.itemValue;
      this.varObser = false;
      this.varDes = false;
    } else {
      if (evento.itemValue.des_referencia == 'OTRO') {
        this.formularioActividades = this.formBuilder.group({
          actividadSelec: [],
          descripcionActividades: [''],
          observacionActividades: ['']
        })
        this.actividadActualSelec = evento.itemValue;
        this.varObser = true;
        this.varDes = true;
      } else {
        this.formularioActividades = this.formBuilder.group({
          actividadSelec: [],
          descripcionActividades: [evento.itemValue.txt_referencia, false],
          observacionActividades: ['']
        })
        this.actividadActualSelec = evento.itemValue;
        this.varObser = true;
        this.varDes = false;
      }
    }
    this.listaActividadesFiltradas = this.listaActividades.filter(opcion => evento.value.find(seleccionado => seleccionado.des_referencia == opcion.des_referencia))
  }

  getListaClientes() {
    this.coreService.get('/obtenerClientes').subscribe(
      (res: any) => {
        this.listaClientes = res.clientes;
        this.listaNegocios = res.unidad;
      },
      (err: any) => {
        console.log(err);
      }
    )

  }

  getListaCargos() {
    let params = {
      id_cliente: this.formulario1.value.clienteSeleccionado.id
    }
    this.coreService.getWithParams('/obtenerCargos', params).subscribe(
      (res: any) => {
        this.listaCargos = res.cargos;
        this.cargoGenerico = res.cargo_generico.cargo_generico_id;
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  getListaJornada() {
    let params = {
      id_cargo: this.formulario1.value.cargoSeleccionado.cargo_espc_id
    }
    this.coreService.getWithParams('/obtenerJornadas', params).subscribe(
      (res: any) => {
        this.formulario2.controls['listaJornadas'].setValue(res.descripcion);
        this.formulario2.controls['listaJornadas2'].setValue(res.id);
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  getListaPerfiles() {
    this.coreService.get('/obtenerPerfil').subscribe(
      (res: any[]) => {
        this.listaPerfil = res;
        if(this.fichaGeneral != null && this.fichaGeneral != undefined) {
          this.perfilSeleccionado = this.listaPerfil.find(perfil => perfil.id == this.fichaGeneral.perfil.id);
        }
      },
      (err: any) => {
        console.log(err);
      }
    )

  }

  getListaCiudad(e) {
    let params = { texto: e.query }
    if (e.query.length > 2) {
      this.coreService.getWithParams('/lugares', params).subscribe(
        (res: any[]) => {
          this.listaCiudad = res;
        },
        (err: any) => {
          console.log(err);
        }
      )
    }
  }

  getListaCaracteristica() {
    this.coreService.get('/obtenerCaracteristica').subscribe(
      (res: any) => {
        this.listaCaracteristica = res;
      },
      (err: any) => {
        console.log(err);
      }
    )

  }

  getListaDocumentos() {
    this.coreService.get('/obtenerValidaciones').subscribe(
      (res: any) => {
        this.listaDocumentos = res.documentos;
        this.listaReferenciacion = res.referenciaciones;
        this.listaPruebas = res.pruebas;
      },
      (err: any) => {
        console.log(err);
      }
    )

  }

  getListaCondiciones() {
    this.coreService.get('/obtenerCondiciones').subscribe(
      (res: any) => {
        this.listaGeneros = res.genero;
        this.listaAspiracion = res.aspiracion;
        this.listaEscolaridad = res.escolaridades;
      },
      (err: any) => {
        console.log(err);
      }
    )

  }

  /**
  * listados Actividades Adicionales
  */
  getListaActividades() {
    this.coreService.get('/listas/actividadesAdicionales').subscribe(
      (res: any) => {

        this.listaActividades = res;
        this.listaActividadesFiltradas = res;
      },
      (err: any) => {
        console.log(err);
      }
    )
  }

  /**
  * listados Actividades Adicionales
  */
  getListaActividadesPorFicha() {
    let params = {
      fichaActual: this.fichaActual
    };
    this.columnasActividades = [
      { header: 'Actividad', field: 'des_referencia' },
      { header: 'Descripción', field: 'descripcion_otra' },
      { header: 'Observación', field: 'observaciones' }
    ];
    this.coreService.getWithParams('/actividades-adicionales-ficha', params).subscribe(
      (res: any) => {
        this.registrosListaActividades = res.actividades;
        this.totalRecordsActividades = res.actividades.length;

      },
      (err: any) => {
        console.log(err);
      }
    )
  }
  /**
  * guardar
  */
  guardar() {
    this.confirmationService.confirm({
      message: '¿Desea guardar este registro?',
      accept: () => {
        this.guardarListado();
      }
    });
  }

  guardarListado() {
    let registros = [];
    this.listaAsignadosConocimientos.forEach(e => {
      registros.push(e);
    });
    this.listaAsignadosCompetencias.forEach(e => {
      registros.push(e);
    });
    this.listaAsignadosHabilidades.forEach(e => {
      registros.push(e);
    });
    let params = {
      registros: registros,
      fichaActual: this.fichaActual
    }
    this.coreService.post('/guardar-ficha', params).subscribe(
      (res: any) => {
        this.msj.info('Registro Guardado Correctamente');
      },
      (err: any) => {
      }
    )
  }

  confirmacionGuardarActividadAdicional() {
    this.confirmationService.confirm({
      message: '¿Desea asignar esta actividad a la ficha?',
      accept: () => {
        this.guardarActividadAdicional();
      }
    });
  }
  guardarActividadAdicional() {
    let params = {
      ficha_id: this.fichaActual,
      actividad_id: this.actividadActualSelec.id,
      descripcion_otra: this.formularioActividades.value.descripcionActividades,
      observaciones: this.formularioActividades.value.observacionActividades
    }
    var actividad_id = this.actividadActualSelec.id;
    if (this.actividadActualSelec.des_referencia == 'OTRO') {

      this.coreService.post('/guardar-actividad-adicional', params).subscribe(
        (res: any) => {
          this.msj.info('Registro Guardado Correctamente');
          this.getListaActividadesPorFicha();
        },
        (err: any) => {
        }
      )
    } else {
      var busqueda = this.registrosListaActividades.filter(function (registro) {
        console.log(registro);
        return registro.actividad_id == actividad_id;
      });
      var firstObj = (busqueda.length > 0) ? busqueda[0] : null;
      if (firstObj == null) {
        this.coreService.post('/guardar-actividad-adicional', params).subscribe(
          (res: any) => {
            this.msj.info('Registro Guardado Correctamente');
            this.getListaActividadesPorFicha();
          },
          (err: any) => {
          }
        )
      } else {
        this.msj.error('La actividad ya ha sido asignada a esta ficha');
      }
    }

  }

  confirmacionEliminarActividadAdicional(id) {
    this.confirmationService.confirm({
      message: '¿Desea eliminar esta actividad?',
      accept: () => {
        this.eliminarActividadAdicional(id);
      }
    });
  }
  eliminarActividadAdicional(id) {
    let params = {
      id: id,
    }
    this.coreService.post('/eliminar-actividad-adicional', params).subscribe(
      (res: any[]) => {
        this.msj.info('Se eliminó la actividad correctamente');
        this.getListaActividadesPorFicha();
      },
      (err: any) => {
        console.log(err);
      }
    );
  }

  guardarnuevo() {
    var dat = this.formulario1.valid;
    var data = this.formulario2.valid;
    this.formulario1.markAllAsTouched();
    this.formulario2.markAllAsTouched();
    if (dat && data) {
      this.confirmationService.confirm({
        message: '¿Desea crear la ficha?',
        accept: () => {
          this.submitted = true;
          this.crearFicha();
        }
      });

    }
  }

  crearFicha() {

    let val1 = this.formulario.valid;
    let val2 = this.formulario1.valid;
    let val3 = this.formulario2.valid;

    this.formulario.markAllAsTouched();
    this.formulario1.markAllAsTouched();
    this.formulario2.markAllAsTouched();

    // validación de estado de formularios
    if (val1 && val2 && val3) {

      let parametros = {
        perfil: this.formulario1.value.perfilSeleccionado.id,
        estado_ficha: this.formulario1.value.estadoSeleccionado.code,
        ciudad: this.formulario1.value.ciudad.cod_ciudad,
        departamento: this.formulario1.value.ciudad.cod_departamento,
        pais: this.formulario1.value.ciudad.cod_pais,
        negocio: this.formulario1.value.negocio.id,
        genero: this.formulario.value.genero.id,
        experiencia: this.formulario.value.experiencia.code,
        escolaridad: this.formulario.value.escolaridad.id,
        semestre: this.formulario.value.semestre,
        entrevista: this.formulario2.value.entrevista,
        informe: this.informe,
        domiciliaria: this.domiciliaria,
        seguridad: this.seguridad,
        entrevista_cliente: this.formulario2.value.entrevista_cliente,
        jornada: this.formulario2.value.listaJornadas2,
        horario: this.formulario2.value.horario,
        documentos_nuevos: this.formulario2.value.documentos_nuevos,
        referenciacion_nuevos: this.formulario2.value.referenciacion_nuevo,
        prueba_nuevos: this.formulario2.value.pruebas_psico,
        variable: this.variable,
        v_variable: this.formulario2.value.v_variable,
        comision: this.comision,
        v_comision: this.formulario2.value.v_comision,
        rodamiento: this.rodamiento,
        v_rodamiento: this.formulario2.value.v_rodamiento,
        movilizacion: this.movilizacion,
        v_movilizacion: this.formulario2.value.v_movilizacion,
        f_basicas: this.formulario2.value.f_basicas,
        r_salarial: this.formulario2.value.rangoSeleccionado,
        estaturamin: this.formulario2.value.estaturamin,
        estaturamax: this.formulario2.value.estaturamax,
        edadmin: this.formulario2.value.edadmin,
        edadmax: this.formulario2.value.edadmax,
        otros: this.formulario2.value.otros,
        restriciones: this.formulario2.value.restriciones,
        fobservaciones: this.formulario2.value.fobservaciones,
        text_publicacion:this.formulario.value.text_publicacion
      }

      if (this.fichaActual) {
        parametros['id'] = this.fichaActual;
        parametros['cliente'] = this.clienteCargado;
        parametros['cargo'] = this.cargoCargado;
        parametros['cargo_generico'] = this.cargoGenerico;
      } else {
        parametros['cliente'] = this.formulario1.value.clienteSeleccionado.id;
        parametros['cargo'] = this.formulario1.value.cargoSeleccionado.cargo_espc_id;
        parametros['cargo_generico'] = this.cargoGenerico;
      }
      
      this.coreService.post('/nueva-ficha', parametros).subscribe(
        (res: any) => {
          this.msj.info(res.mensaje);
          if (!this.fichaActual) {
            this.fichaActual = (res.ficha.id);
            this.formulario1.controls['clienteCargado'].setValue(this.formulario1.value.clienteSeleccionado.nombre);
            this.formulario1.controls['cargoCargado'].setValue(this.formulario1.value.cargoSeleccionado.descripcion);
            this.clienteCargado = this.formulario1.value.clienteSeleccionado.id;
            this.cargoCargado = this.formulario1.value.cargoSeleccionado.cargo_espc_id;
          }
          this.registroNuevo = false;
          this.crearProcesos();
        },
        (err: any) => {
            console.log(err);
            
        }
      )
    } else {
      this.msj.alerta('Por favor revisar diligenciar todos los campos obligatorios')
    }
  }

  guardarcondiciones() {

    this.confirmationService.confirm({
      message: '¿Desea guardar los registros?',
      accept: () => {
        this.submitted = true;
        this.crearCondiciones();
      }
    });

  }

  crearCondiciones() {

    let params = {
      ficha_nueva: this.fichaActual,
      genero: this.formulario.value.genero.id,
      experiencia: this.formulario.value.experiencia.code,
      escolaridad: this.formulario.value.escolaridad.id,
      semestre: this.formulario.value.semestre,

    }
    this.coreService.post('/guardarCondiciones', params).subscribe(
      (res: any) => {
        this.msj.info(res.mensaje);
      },
      (err: any) => {
      }
    )
  }

  guardarprocesos() {

    this.confirmationService.confirm({
      message: '¿Desea guardar los registros?',
      accept: () => {
        this.submitted = true;
        this.crearProcesos();
      }
    });

  }

  crearProcesos() {

    let params = {
      ficha_nueva: this.fichaActual,
      entrevista: this.formulario2.value.entrevista,
      informe: this.informe,
      domiciliaria: this.domiciliaria,
      seguridad: this.seguridad,
      entrevista_cliente: this.formulario2.value.entrevista_cliente,
      jornada: this.formulario2.value.listaJornadas2,
      horario: this.formulario2.value.horario,
      documentos_nuevos: this.formulario2.value.documentos_nuevos,
      referenciacion_nuevos: this.formulario2.value.referenciacion_nuevo,
      prueba_nuevos: this.formulario2.value.pruebas_psico,
      variable: this.variable,
      v_variable: this.formulario2.value.v_variable,
      comision: this.comision,
      v_comision: this.formulario2.value.v_comision,
      rodamiento: this.rodamiento,
      v_rodamiento: this.formulario2.value.v_rodamiento,
      movilizacion: this.movilizacion,
      v_movilizacion: this.formulario2.value.v_movilizacion,
      f_basicas: this.formulario2.value.f_basicas,
      r_salarial: this.formulario2.value.rangoSeleccionado,

    }
    this.coreService.post('/guardarProcesos', params).subscribe(
      (res: any) => {

      },
      (err: any) => {
      }
    )
  }

  asignarFichaGeneral() {
    this.formulario1.controls['perfilSeleccionado'].setValue(this.listaPerfil.find(perfil => perfil.id == (this.fichaGeneral.perfil ? this.fichaGeneral.perfil.id : '')));
    this.formulario1.controls['estadoSeleccionado'].setValue(this.estadoFicha.find(estado => estado.code == this.fichaGeneral.active));
    this.formulario1.controls['negocio'].setValue(this.listaNegocios.find(negocio => negocio.id == (this.fichaGeneral.unidad_negocio_id ? this.fichaGeneral.unidad_negocio_id : '')));
    this.formulario1.controls['ciudad'].setValue(this.fichaGeneral.ciudad_id == "" ? null : this.fichaGeneral.ciudad_id);
    this.formulario1.controls['pais'].setValue(this.fichaGeneral.pais_id == "" ? null : this.fichaGeneral.pais_id);
    this.formulario1.controls['departamento'].setValue(this.fichaGeneral.departamento_id == "" ? null : this.fichaGeneral.departamento_id);
    this.formulario.controls['genero'].setValue(this.listaGeneros.find(genero => genero.id == this.fichaGeneral.genero));
    this.formulario.controls['experiencia'].setValue(this.listaExperiencias.find(experiencia => experiencia.code == this.fichaGeneral.experiencia));
    this.formulario.controls['escolaridad'].setValue(this.listaEscolaridad.find(escolaridad => escolaridad.id == this.fichaGeneral.escolaridad));
    this.formulario2.controls['rangoSeleccionado'].setValue(this.listaAspiracion.find(rango => rango.id == this.fichaGeneral.rango_salarial));
    this.formulario2.controls['f_basicas'].setValue(this.fichaGeneral.funciones_realizar);
    this.informe = this.fichaGeneral.req_informe_seleccion.trim();
    this.seguridad = this.fichaGeneral.req_estudio_seguridad.trim();
    this.domiciliaria = this.fichaGeneral.req_visita_domiciliaria.trim();
    this.variable = this.fichaGeneral.variable.trim();
    this.formulario2.controls['v_comision'].setValue(this.fichaGeneral.valor_comision);
    this.formulario2.controls['v_rodamiento'].setValue(this.fichaGeneral.valor_rodamiento);
    this.formulario2.controls['v_movilizacion'].setValue(this.fichaGeneral.valor_movilizacion);
    this.formulario2.controls['v_variable'].setValue(this.fichaGeneral.valor_variable);
    this.comision = this.fichaGeneral.comision.trim();
    this.rodamiento = this.fichaGeneral.rodamiento.trim();
    this.movilizacion = this.fichaGeneral.movilizacion.trim();
    this.formulario2.controls['horario'].setValue(this.fichaGeneral.observaciones_horario);
    this.formulario2.controls['listaJornadas'].setValue(this.FichaJornada.descripcion == "" ? null : this.FichaJornada.descripcion);
    this.formulario2.controls['estaturamin'].setValue(this.fichaGeneral.estatura_minima);
    this.formulario2.controls['estaturamax'].setValue(this.fichaGeneral.estatura_maxima);
    this.formulario2.controls['edadmin'].setValue(this.fichaGeneral.edad_minima);
    this.formulario2.controls['edadmax'].setValue(this.fichaGeneral.edad_maxima);
    this.formulario2.controls['otros'].setValue(this.fichaGeneral.otros_fisicas);
    this.formulario2.controls['restriciones'].setValue(this.fichaGeneral.restricciones);
    this.formulario2.controls['fobservaciones'].setValue(this.fichaGeneral.observaciones_generales);

    console.log(this.fichaGeneral.text_publicacion);
    
    if (this.fichaActividad) {
      this.formularioActividades.controls['actividadSelec'].setValue([this.listaActividadesFiltradas.find(actividad_id => actividad_id.id == this.fichaActividad.actividad_id)]);
      this.formularioActividades.controls['descripcionActividades'].setValue(this.fichaActividad.descripcion_otra);
      this.formularioActividades.controls['observacionActividades'].setValue(this.fichaActividad.observaciones);
    }

    this.spinner.hide();
  }

}
